import { Link } from '@/components/link';

export function TranslatedLink(props: TypeAny) {
  return <Link {...props} />;
}

export function TranslatedButton(props: TypeAny) {
  // eslint-disable-next-line react/button-has-type
  return <button {...props} />;
}
